module.exports = __webpack_public_path__ + "static/media/Honda_main_preview.856d0329.jpg";